import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import { build as constants } from './../helpers';
import { uniq } from 'lodash';

import SelectComponent from './SelectComponent';

import {
  FormGroup,
  Col,
  ControlLabel,
  Checkbox
} from 'react-bootstrap';

export default class BuildHealthSelectorComponent extends React.Component {
  static propTypes = {
    buildHealthPageInfo: PropTypes.shape(
      {
        product: PropTypes.string,
        buildNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        buildId: PropTypes.number,
        buildIds: PropTypes.array,
        extended: PropTypes.bool
      }
    ).isRequired,
    builds: PropTypes.array,
    onSubmit: PropTypes.func.isRequired
  };

  getBuildNumbersBySelectedProduct(builds) {
    const buildNumbers = builds ? uniq(builds.map(b => b.build)) : [];
    return buildNumbers.sort((a, b) => b - a);
  }

  getBuildIdBySelectedBuild(builds, buildNumber)
  {
    if (isNaN(buildNumber)) { return 0; }
    const filteredBuilds = builds.filter(b => b.build === buildNumber);
    const buildIds = filteredBuilds ? filteredBuilds.map(b => b.id) : [0];
    return buildIds;
  }

  getProductNameOptions = () => {
    const options = constants.BUILD_TYPE_VALUES[constants.BUILD_PRODUCTION];
    return options ? options : [];
  };

  render() {
    const {
      builds,
      buildHealthPageInfo,
      onSubmit
    } = this.props;


    const initialState = {
      product: buildHealthPageInfo.product,
      buildNumber: buildHealthPageInfo.buildNumber,
      buildIds: buildHealthPageInfo.buildIds,
      extended: buildHealthPageInfo.extended
    };

    const buildsSelectedByProduct = builds;
    const buildNumbers =
    this.getBuildNumbersBySelectedProduct(buildsSelectedByProduct);

    return (
      <div>
        <LocalForm
          id="build-health-selector-form"
          model="buildHealth"
          onChange={onSubmit}
          initialState={initialState}
        >
          <FormGroup>
            <Col md={3}>
              <ControlLabel>
                Product Name:
              </ControlLabel>
              <Control.custom
                id="productName-input"
                model="."
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: this.getProductNameOptions(),
                    selected: modelValue.product,
                    onChange: d => {
                      const model = {
                        ...modelValue,
                        product: d,
                        buildNumber: 0,
                        buildIds: ['0']
                      };
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={3}>
              <ControlLabel>
                Build#:
              </ControlLabel>
              <Control.custom
                id="buildNumber-input"
                model="."
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: buildNumbers,
                    selected: modelValue.buildNumber,
                    onChange: d => {
                      const model = {
                        ...modelValue,
                        buildNumber: +d,
                        buildIds: this.getBuildIdBySelectedBuild(
                          buildsSelectedByProduct, +d)
                      };
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={5}>
              <ControlLabel> Include </ControlLabel>
              <div>
                <Control.custom
                  id="unextend-build-check"
                  component={Checkbox}
                  model="."
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      onChange: c => {
                        const model = {
                          ...modelValue,
                          buildNumber: 0,
                          buildIds: ['0'],
                          extended:!c.target.checked
                        };
                        onChange(model);
                      },
                      checked: !modelValue.extended
                    };
                  }}
                  inline
                >
                  RCs since lastest release
                </Control.custom>
                <Control.custom
                  id="extend-build-check"
                  component={Checkbox}
                  model="."
                  mapProps={({ modelValue, onChange }) => {
                    return {
                      onChange: c => {
                        const model = {
                          ...modelValue,
                          buildNumber: 0,
                          buildIds: ['0'],
                          extended:c.target.checked
                        };
                        onChange(model);
                      },
                      checked: modelValue.extended
                    };
                  }}
                  inline
                >
                  All RCs
                </Control.custom>
              </div>
            </Col>
          </FormGroup>
        </LocalForm>
      </div>
    ); }
}


// WEBPACK FOOTER //
// src/Components/BuildHealthSelectorComponent.jsx